import * as React from "react";
import { useUser } from "./context/user-context";
import { LoginForm } from "./LoginForm";
import { Main } from "@agent/Main";
import { WishListProvider } from "@agent/context/wish-list";

export function Agent() {
  const { loggedIn } = useUser();

  if (!loggedIn) {
    return <LoginForm />;
  }

  return (
    <WishListProvider>
      <Main />
    </WishListProvider>
  );
}
